module.exports = __webpack_public_path__ + "static/media/EVgo_FC_color_transparent.9f395622.png";


//////////////////
// WEBPACK FOOTER
// ./src/component/img/EVgo_FC_color_transparent.png
// module id = 824
// module chunks = 0